import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';

import { Observable } from 'rxjs';
import { environment } from '@env/environment';

export interface CaseResponse {
  caseId: string;
  message: string;
}

@Injectable({
  providedIn: 'root',
})
export class CaseService {
  private baseUrl = environment.apiForm;

  constructor(private http: HttpClient) {}

  createCase(formData: any): Observable<CaseResponse> {
    return this.http.post<CaseResponse>(`${this.baseUrl}/case`, formData);
  }

  extensionCase(formData: any): Observable<CaseResponse> {
    return this.http.post<CaseResponse>(`${this.baseUrl}/extension`, formData);
  }
}
